import { render } from "./info_company.vue?vue&type=template&id=98fdc1b6&scoped=true"
import script from "./info_company.vue?vue&type=script&lang=js"
export * from "./info_company.vue?vue&type=script&lang=js"

import "./info_company.vue?vue&type=style&index=0&id=98fdc1b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\holo\\work\\git-all-source,\\stress_check_Rebuild\\source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98fdc1b6"]])

export default __exports__